'use client';

import { cx } from '@/src/styles/stylebook';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useEffect, useState, useRef, useLayoutEffect } from 'react';
import { MenuBall } from '../frame/Ball';
import Multilingual from '../../global/Multilingual';
import { Ham } from './MobGNB';
import useScreenSize from '@/src/hooks/useScreenSize';
import { MobLogo } from './Logo';
export function Menu(props) {
  const {
    data,
    year
  } = props;
  const {
    width
  } = useScreenSize();
  const pathname = usePathname();
  const [hamStatus, setHamStatus] = useState(false);
  const [isOpen, setIsOpen] = useState({
    status: false,
    item: null
  });
  const submenuRefs = useRef({});
  const [submenuHeights, setSubmenuHeights] = useState({});
  const handleOpen = (status, slug) => {
    // 데스크톱에서만 동작하도록 제한
    if (width >= 768) {
      setIsOpen({
        status: status,
        item: status ? slug : null
      });
    }
  };
  const handleMobileToggle = (e, slug_0) => {
    // 모바일에서만 동작하는 토글 함수
    if (width < 768) {
      e.preventDefault(); // 링크 이동 방지
      setIsOpen(prev => ({
        status: prev.item === slug_0 ? false : true,
        item: prev.item === slug_0 ? null : slug_0
      }));
    }
  };
  useEffect(() => {
    // 모바일에서 pathname 변경 시 햄버거 메뉴 닫기
    if (width < 768) {
      setHamStatus(false);
    }
  }, [width, pathname]);

  // 현재 pathname에 따라 해당 메뉴를 자동으로 열기 (가장 먼저 실행)
  useLayoutEffect(() => {
    const currentMenu = data.find(menuItem => pathname.includes(`/${menuItem.slug?.current}`));
    if (currentMenu && currentMenu.subMenu && currentMenu.subMenu.length > 0) {
      setIsOpen({
        status: true,
        item: currentMenu.slug?.current || null
      });
    }
  }, [pathname, data]);

  // 서브메뉴 높이 계산 및 업데이트 (isOpen 상태 변경 후 실행)
  useLayoutEffect(() => {
    // 약간의 지연을 두어 DOM이 완전히 렌더링된 후 높이 계산
    const timer = setTimeout(() => {
      const heights = {};
      data.forEach(menuItem_0 => {
        if (menuItem_0.slug?.current && submenuRefs.current[menuItem_0.slug.current]) {
          const element = submenuRefs.current[menuItem_0.slug.current];
          if (element) {
            // 임시로 maxHeight를 auto로 설정해서 실제 높이 측정
            const originalMaxHeight = element.style.maxHeight;
            element.style.maxHeight = 'none';
            heights[menuItem_0.slug.current] = element.scrollHeight;
            element.style.maxHeight = originalMaxHeight;
          }
        }
      });
      setSubmenuHeights(heights);
    }, 10);
    return () => clearTimeout(timer);
  }, [data, isOpen]);

  // 추가: 데스크톱으로 변경될 때도 햄버거 메뉴 닫기
  useEffect(() => {
    if (width >= 768) {
      setHamStatus(true);
    }
  }, [width]);
  if (!data || data.length === 0) {
    return null;
  }
  return <>
      <ul className={cx(
    // pc
    'text-gnb m-0 flex gap-x-[1.875rem] font-bold max-lg:gap-x-[1.2rem]', hamStatus ? 'block' : 'hidden',
    // mobile
    'max-md:pt-[calc(var(--spacing-gutter)*2+var(--spacing-ham))]', 'max-md:gap-y-gutter max-md:px-marg scroll-hide max-md:fixed max-md:top-0 max-md:right-0 max-md:bottom-0 max-md:left-0 max-md:max-h-screen max-md:flex-col max-md:items-start max-md:justify-start max-md:overflow-y-auto max-md:bg-green-50 max-md:pb-20 max-md:text-[2.85rem]')} data-lenis-prevent>
        {/* <OptimisticSortOrder id={data?._id!} path="menuItems"> */}
        {data.map((menuItem_1, i) => {
        if (!menuItem_1.active) return null;
        const href = menuItem_1.subMenu && menuItem_1.subMenu.length > 0 ? `/${menuItem_1.slug?.current}/${menuItem_1.subMenu[0].slug?.current}` : `/${menuItem_1.slug?.current}`;
        return <li key={`${menuItem_1.slug?.current}_${i}`} className="" onMouseEnter={() => handleOpen(true, menuItem_1.slug?.current || '')} onMouseLeave={() => handleOpen(false, menuItem_1.slug?.current || '')}>
              <Link href={href} onClick={e_0 => {
            // 서브메뉴가 있고 모바일인 경우에만 링크 이동 방지
            if (width < 768 && menuItem_1.subMenu && menuItem_1.subMenu.length > 0) {
              e_0.preventDefault();
              handleMobileToggle(e_0, menuItem_1.slug?.current || '');
            }
          }}>
                <Multilingual>{menuItem_1.title}</Multilingual>
              </Link>
              {pathname.includes(`/${menuItem_1.slug?.current}`) && <span className="absolute top-0 right-[-0.5625em] mix-blend-multiply max-md:hidden">
                  <MenuBall className="fill-green-50" />
                </span>}
              {menuItem_1.subMenu && menuItem_1.subMenu.length > 0 && <ul ref={el => {
            if (menuItem_1.slug?.current) {
              submenuRefs.current[menuItem_1.slug.current] = el;
            }
          }} className={cx('gap-x-gutter absolute m-0 w-max md:!hidden', 'max-md:h2 max-md:h4 max-md:relative max-md:overflow-hidden max-md:pl-8 max-md:transition-all max-md:duration-300 max-md:ease-in-out'
          // 데스크탑에서는 hover 상태에 따라 표시/숨김
          // width >= 768 && !(isOpen.status && isOpen.item === menuItem.slug?.current) ? 'hidden' : ''
          )} style={{
            maxHeight: isOpen.status && isOpen.item === menuItem_1.slug?.current ? `${submenuHeights[menuItem_1.slug?.current || '190px'] || submenuRefs.current[menuItem_1.slug?.current || '']?.scrollHeight || 190}px` : '0px'
          }}>
                  {menuItem_1.subMenu.map((subMenuItem, j) => {
              if (!subMenuItem.active) return null;
              return <li key={`${menuItem_1.slug?.current}_${subMenuItem.slug?.current}_${j}`} className="flex max-md:first:pt-2 max-md:last:pb-2">
                        <Link href={`/${menuItem_1.slug?.current}/${subMenuItem.slug?.current}`} className={cx('max-md:py-1.5',
                //mobile
                pathname.includes(subMenuItem.slug?.current || '') ? 'max-md:opacity-100' : 'max-md:opacity-50')}>
                          <Multilingual>
                            {`${subMenuItem.slug?.current === 'overview' ? `${year} ` : ''}${subMenuItem.title}`}
                          </Multilingual>
                        </Link>
                      </li>;
            })}
                </ul>}
            </li>;
        // const href = resolveHref(menuItem?._type, menuItem?.slug)
        // if (!href) {
        //   return null
        // }
        // return (
        //   <Link
        //     key={menuItem._key}
        //     className={`text-lg hover:text-black md:text-xl ${
        //       menuItem?._type === 'home' ? 'font-extrabold text-black' : 'text-gray-600'
        //     }`}
        //     href={href}
        //   >
        //     {stegaClean(menuItem.title)}
        //   </Link>
        // )
      })}
        {/* </OptimisticSortOrder> */}
      </ul>
      <Link href="/" className={cx('fixed top-[calc(var(--spacing-gutter)*2-1.15rem)] left-[calc(var(--spacing-marg)*2-1rem)] aspect-[126/48] h-[calc(var(--spacing-ham)+0.6rem)] origin-top-left md:hidden'
    // hamStatus ? 'mix-blend-multiply' : ''
    )}>
        <MobLogo />
      </Link>
      <Ham status={hamStatus} setStatus={setHamStatus} />
    </>;
}
export default Menu;